import { getKnowledgePointsDepartmentList } from '../../../service/knowledgePoint';
import { SWITCH_STATUS } from '../../../interface';
import { getWorkspaceDepartmentList } from '../../../../../components/departmentAndMemberSearch/service/workspace';

const defaultPage = 1;

const onIsRoot = (searchId: string) => {
    return searchId === '' || !searchId || String(searchId) === '0' ? SWITCH_STATUS.YES : SWITCH_STATUS.NO;
};
const getKnowledgeDepartmentSearchList = async (searchId: string, isRoot: SWITCH_STATUS, page: number) => {
    const data = await getKnowledgePointsDepartmentList({
        is_root: isRoot,
        current_department_id: searchId,
        size: 50,
        page,
    });
    return data;
};

const getWorkspaceDepartmentSearchList = async (searchId: string, isRoot: SWITCH_STATUS, page: number) => {
    const data = await getWorkspaceDepartmentList({
        is_root: isRoot,
        current_department_id: searchId,
        size: 50,
        page,
    });
    return data;
};

export { onIsRoot, getKnowledgeDepartmentSearchList, getWorkspaceDepartmentSearchList, defaultPage };
